var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"twoLineText",class:{ threeLineText: _vm.isExpanded },domProps:{"innerHTML":_vm._s(_vm.displayText)},on:{"click":function($event){$event.stopPropagation();return _vm.textClicked()}}})}
var staticRenderFns = []

export { render, staticRenderFns }